import { render } from "./imgMerge.vue?vue&type=template&id=4735122e&scoped=true"
import script from "./imgMerge.vue?vue&type=script&lang=js"
export * from "./imgMerge.vue?vue&type=script&lang=js"

import "./imgMerge.vue?vue&type=style&index=0&id=4735122e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4735122e"

export default script